export const SHORT_LIST_ITEMS_LENGTH = 10;
